import { useEffect } from 'react'

import { useAppSelector } from '../../../store/hooks'
import { useActions } from '../../../store/use-actions'
import { actions as rawActions } from '../state/terms-slice'
import { TermsStateless } from '../templates/terms-stateless'

export function TermsStep() {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.terms)
  const actions = useActions(rawActions)

  useEffect(() => {
    actions.reset()

    if (builderState.note && builderState.client && builderState.businessUnit) {
      actions.init({
        note: builderState.note,
        client: builderState.client,
        businessUnit: builderState.businessUnit
      })
    }
  }, [
    builderState.termsKey,
    builderState.client,
    builderState.note,
    builderState.businessUnit,
    actions
  ])

  return <TermsStateless actions={actions} state={state} />
}
